import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { DataTable, StatusBadge } from "@/components/DataTable";
import { toast } from "sonner";

export default function AttendancePage() {
  const [students, setStudents] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [batch, setBatch] = useState("");
  const [batches, setBatches] = useState([]);
  const today = new Date().toISOString().slice(0,10);

  const load = async () => {
    const [{data:s},{data:b},{data:a}] = await Promise.all([api.get("/students"), api.get("/batches"), api.get("/attendance")]);
    setStudents(s); setBatches(b); setAttendance(a);
  };
  useEffect(()=>{load()},[]);

  const mark = async (student, status) => {
    await api.post("/attendance", {
      student_id: student.id, student_name: student.name,
      batch_id: student.batch_id, batch_name: student.batch_name,
      date: today, status,
    });
    toast.success(`${student.name} marked ${status}`);
    load();
  };

  const filtered = batch ? students.filter(s => s.batch_id === batch) : students;
  const todayAttendance = attendance.filter(a => a.date === today);

  const getStatus = (studentId) => {
    const a = todayAttendance.find(x => x.student_id === studentId);
    return a?.status;
  };

  return (
    <div>
      <PageHeader
        title="Attendance"
        subtitle={`Mark attendance for ${today}`}
        actions={
          <select value={batch} onChange={e=>setBatch(e.target.value)} data-testid="attendance-batch-select" className="px-3 py-2 border border-[#E0DFDC] rounded-md bg-white text-sm">
            <option value="">All batches</option>
            {batches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
          </select>
        }
      />

      <DataTable
        testid="attendance-table"
        columns={[
          { key:"roll_no", label:"Roll" },
          { key:"name", label:"Student" },
          { key:"batch_name", label:"Batch" },
          { key:"today", label:"Today", render: s => {
            const st = getStatus(s.id);
            return st ? <StatusBadge status={st}/> : <span className="text-[#00000066] text-xs">Not marked</span>;
          }},
          { key:"actions", label:"Actions", render: s => (
            <div className="flex gap-2">
              <button data-testid={`mark-present-${s.id}`} onClick={()=>mark(s, "present")} className="text-xs px-3 py-1 rounded-full bg-[#057642]/10 text-[#057642] hover:bg-[#057642]/20 font-semibold">Present</button>
              <button data-testid={`mark-absent-${s.id}`} onClick={()=>mark(s, "absent")} className="text-xs px-3 py-1 rounded-full bg-[#CC1016]/10 text-[#CC1016] hover:bg-[#CC1016]/20 font-semibold">Absent</button>
            </div>
          )},
        ]}
        rows={filtered}
      />
    </div>
  );
}
